/**
 * 主界面右侧边栏组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
	<div id="right-sidebar" :class="activeClass">
		<div class="sidebar-container" v-slimScroll="{height:'100%',railOpacity:0.4,wheelStep:10}">

			<ul class="nav nav-tabs navs-3">

				<li class="active">
					<a data-toggle="tab" href="#tab-1">
						<i class="fa fa-gear"></i> 主题
					</a>
				</li>
				<li class="">
					<a data-toggle="tab" href="#tab-2">
						通知
					</a>
				</li>
				<li>
					<a data-toggle="tab" href="#tab-3">
						项目进度
					</a>
				</li>
			</ul>

			<div class="tab-content">
				<div id="tab-1" class="tab-pane active">
					<div class="sidebar-title">
						<h3> <i class="fa fa-comments-o"></i> 主题设置</h3>
						<small><i class="fa fa-tim"></i> 你可以从这里选择和预览主题的布局和样式，这些设置会被保存在本地，下次打开的时候会直接应用这些设置。</small>
					</div>
					<div class="skin-setttings">
						<div class="title">主题设置</div>
						<div class="setings-item">
							<span>固定顶部</span>

							<SwitchBox v-on:checkChange="fixedNav" switchName="fixNav"></SwitchBox>
						</div>
						<div class="title">皮肤选择</div>
						<div class="setings-item default-skin nb">
							<span class="skin-name ">
                         <a  @click="changetheme('')">
                             默认皮肤
                         </a>
                    </span>
						</div>
						<div class="setings-item blue-skin nb">
							<span class="skin-name ">
                        <a  @click="changetheme('skin-1')">
                            蓝色主题
                        </a>
                    </span>
						</div>
						<div class="setings-item yellow-skin nb">
							<span class="skin-name ">
                        <a  @click="changetheme('skin-3')">
                            黄色/紫色主题
                        </a>
                    </span>
						</div>
					</div>
				</div>
				<div id="tab-2" class="tab-pane">

					<div class="sidebar-title">
						<h3> <i class="fa fa-comments-o"></i> 最新通知</h3>
						<small><i class="fa fa-tim"></i> 您当前有10条未读信息</small>
					</div>

					<div>

					</div>
				</div>
				<div id="tab-3" class="tab-pane">
					<div class="sidebar-title">
						<h3> <i class="fa fa-cube"></i> 最新任务</h3>
						<small><i class="fa fa-tim"></i> 您当前有14个任务，10个已完成</small>
					</div>
					
					<ul class="sidebar-list">
						

					</ul>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import SwitchBox from 'components/common/SwitchBox'
	export default {
		name: 'RightSidebar',
		components: {
			SwitchBox
		},
		data() {
			return {

			};
		},
		methods:{
			changetheme: function (val) {
				this.$store.dispatch('changetheme',val)
			},
			fixedNav: function(checkValue) {
    			this.$store.dispatch('fixednav',checkValue);
    		}
		},
		computed:{
		  	 activeClass() {
		  	 	return {
		       		'sidebar-open': this.$store.state.global.rightsidebar
				   }
		       	}
		}
	};
</script>


// WEBPACK FOOTER //
// RightSidebar.vue?15c3464e